$( document ).ready(function(e) {
  // URL-restricted public token, set per environment in application.yml (#811).
  L.mapbox.accessToken = document.querySelector('meta[name="mapbox-token"]').content;
  var instagiftStyle = L.mapbox.styleLayer('mapbox://styles/instagift/cipsq4umu0000bom3xh6fh1gt');

  var instagiftIcon = L.mapbox.marker.icon({
    'marker-symbol': "gift",
    'marker-color': '#ED5D32'
  });

  var defaultPolygonColor = "grey";
  var nickname = $("#map").data("nickname");
  var merchantData = null;
  var shuffledMerchants = null;
  var alphabetizedMerchants = null;

  var map = L.map(
    'map',
    {
      scrollWheelZoom: false,
      doubleClickZoom: false,
      layers: [instagiftStyle, L.mapbox.tileLayer('mapbox.streets')]
    }
  );

  var listings = document.getElementById('listings');
  var markers = [];
  var polygons = [];
  var boundPointsForMap = [];
  var clusterGroup = new L.MarkerClusterGroup({
    iconCreateFunction: function (cluster) {
      var childCount = cluster.getChildCount();

      return new L.DivIcon({
        html: childCount,
        className: 'ig-cluster',
        iconSize: L.point(30, 30)
      });
    },
    maxClusterRadius: 30,
    showCoverageOnHover: false,
  });

  $("#groups-only").on("change", function (e){
    if (this.checked) {
      $(".item").removeClass("group-hide");
      $(".item.individual").addClass("individual-hide");
    }
  });

  $("#individuals-only").on("change", function (e){
    if (this.checked) {
      $(".item").removeClass("individual-hide");
      $(".item.group").addClass("group-hide");
    }
  });

  $("#all-cards").on("change", function (e){
    if (this.checked) {
      $(".item").removeClass("group-hide individual-hide");
    }
  });

  $("#deals-only").on("change", function(e) {
    if (this.checked) {
      $(".item:not(.deal)").addClass("non-deal-hide");
    } else {
      $(".item").removeClass("non-deal-hide");
    }
    $(".item").attr("style", "");
  });

  $("html").on("click", ".item .close-item", function(e) {
    closeActive();
    window.location.hash = '';
    $("#alphabetize").trigger("change");

    e.preventDefault();
    return false;
  });

  $(document).keyup(function(e) {
    if (e.keyCode === 27) $('.close-item').click();
  });

  $("html").on('click', 'a.cross', function (e) {
    if ($(".leaflet-popup-close-button").length){
      $(".leaflet-popup-close-button")[0].click();
    }

    var slug = $(this).attr('href').substring(1);
    $("#" + slug).trigger('click');

    e.preventDefault();
    return false;
  });

  $("#toggle-overlay").on('click', function (e) {
    $(".overlay").attr("style", "");
    $(".overlay").removeClass("closed");
    $(".how-it-works, .overlay .container").addClass("hide");
    $(".overlay #cover").removeClass("hide");

    e.preventDefault();
  });

  $(".overlay").on('click', function (e){
    var tag = e.target;
    if (tag.tagName == "svg" || tag.tagName == "path") { return false; }
    if (tag.tagName != "A" || tag.classList.contains("start-shopping")) {
      $(this).addClass('closed');
      $(".how-it-works").removeClass("hide");
      var src = $("#how-it-works-video")[0].src;
      $("#how-it-works-video")[0].src = src.replace("?autoplay=1", "");
      return false;
    }
  });

  $('#search').on('keyup', function () {
    var query = this.value.toLowerCase();

    $("#listings").find('.item').each(function () {
      comp = $(this).find(".item-name").text().toLowerCase();
      $(this).toggle(comp.indexOf(query) != -1);
    });
  });

  $("a.cover-nav-link").on("click", function(e) {
    e.preventDefault();
    var href = this.dataset.target;
    var hash = href.substr(href.indexOf("#"));

    if ($(".container" + hash).length) {
      $(".overlay .container").addClass("hide");
      $(hash).removeClass("hide");
    } else {
      $(hash).click();
      $(".overlay").click();
    }

    if ($(this).attr('href') == '#how-it-works') {
      $("#how-it-works-video")[0].src += "?autoplay=1";
    } else {
      var src = $("#how-it-works-video")[0].src;
      $("#how-it-works-video")[0].src = src.replace("?autoplay=1", "");
    }

    e.preventDefault();
    return false;
  });

  $("#alphabetize").on("change", function(e) {
    $("#listings").html("<div id='featured'></div>");

    clusterGroup.clearLayers();
    markers = [];

    getGroups();
  });

  var setActive = function($listing, event) {
    $(".item").removeClass("active");
    $(".item, .dropdowns").addClass("hide");
    $listing.addClass("active");
    $listing.removeClass("hide");
    $(".item .buy-now-button, .item .extra, .item .close-item, .item .offer").addClass("hide");
    $listing.find(".buy-now-button, .extra, .close-item, .offer").toggleClass("hide");
    $(".item .circle").addClass("hide");
    $("#search").val("").blur().trigger("keyup");

    if (event.type != "popstate") {
      ga('set', 'page', ('/' + slug + '#' + $listing[0].id));
      ga('send', 'pageview');

      history.pushState(null, null, '#' + $listing[0].id);
    }
  };

  var closeActive = function() {
    var container = $("#listings #featured");
    var scrollTo = $(".item.active:not(.featured)");

    $(".item:not(.featured) .buy-now-button, .item .extra, .item .close-item, .item .offer").addClass("hide");
    $(".item").removeClass("active hide");
    $(".item.featured").addClass("active");
    $(".item .circle, .dropdowns").removeClass("hide");

    if (scrollTo === []) { return true; }

    setMapBounds();

    if ($(".leaflet-popup-close-button").length){
      $(".leaflet-popup-close-button")[0].click();
    }

    polygons.map(function(polygon) {
      map.addLayer(polygon);
      polygon.setStyle({color: defaultPolygonColor })
    });

    clusterGroup.clearLayers();
    markers.forEach(function(marker) {
      clusterGroup.addLayer(marker);
      marker.clickActivated = false;
    });

    container.scrollTop(
      scrollTo.offset().top - container.offset().top + container.scrollTop()
    );
  }

  var addFeaturedListing = function(json) {
    var listing = document.getElementById('featured').appendChild(document.createElement('div'));

    var html = "";

    html += "  <div id='foo'>"
    html += "    <div class='details'>";
    if (json.offers.length) {
      html += "      <h2>Featured Deal</h2>";
    } else {
      html += "      <h2>Featured Merchant</h2>";
    }
    html += "      <h3>" + json.name + "</h3>"
    html += "      <img src='" + json.card_image + "' class='image h-100'>";

    if (json.offers.length) {
      html += "      <div class='title'><span class='item-name'> Buy $" + json.offers[0].x + ", get $" + json.offers[0].y + "</span></div>";
      html += "      <i>Limited Time offer. Restrictions Apply.</i>"
    }
    html += "      <a href='https://" + json.slug + ".instagift.com?rc=" + nickname + "&por=1' class='btn btn-primary btn-block buy-now-button' target='_blank'>Buy Now</a>";
    html += "    </div>";
    html += "  </div>";

    $(listing).html(html);
    $(listing).addClass('item featured active');
  };

  var addMerchantListing = function(json) {

    json.locations.forEach(function(locationJson){
    if (locationJson.omit_listing) {
      return true;
    }

    var listing = listings.appendChild(document.createElement('div'));
    var lat = locationJson.latitude;
    var lng = locationJson.longitude;
    var latlng = L.latLng(lat, lng);

    if (!locationJson.outlier) { boundPointsForMap.push(latlng); }

    listing.id = json.slug + "-" + locationJson.id;

    var html = "";
    if (json.offers.length) {
      html += "<div class='offer hide'>";
      html += "  <h3>Buy a $" + json.offers[0].x + " gift card & get a bonus $" + json.offers[0].y + "</h3>";
      html += 'This offer expires soon. Click "Buy Now" for details.';
      html += "</div>";
    }
    html += "  <a href='#' class='hide close-item float-right'>close <i class='fas fa-times-circle' aria-hidden='true'></i></a>"
    html += "  <div class='details'><img src='" + json.card_image + "' class='image h-100'></div>";
    html += "  <div class='details'>";
    html += "    <div class='title'><span class='item-name'>" + locationJson.name + "</span>";
    html += "      <br>";
    html += "      <small class='quiet'>"
    html +=          locationJson.address;
    html += "        <br>";
    if (json.phone) {
      html += locationJson.phone
    }
    html+= "       </small>"
    html += "    </div>";

    if (!json.group_card_only) {
      html += "<a href='https://" + json.slug + ".instagift.com?rc=" + nickname + "&por=1' class='btn btn-primary btn-lg buy-now-button pull-left hide' target='_blank'>Buy Now</a>";
    }
    html += "  </div>";
    if (json.offers.length) {
      html += "<div class='details float-right circle'>";
      html += "<p><div class='amt'>$" + json.offers[0].y + "</div>Free</p>";
      html += "</div>";
    }
    html += "  <div class='clearfix'></div>";
    html += "  <div class='extra hide'>"
    if (json.group_cards.length) {
      html += "<ul>";

      if (json.group_card_only) {
        html += "<h6>Only available as part of the following group cards:</h6>";
      } else {
        html += "<h6>Also a member of the following group cards:</h6>";
      }

      json.group_cards.forEach(function(groupCard){
        html += "<li>";
        html += "<a href='#" + groupCard.slug + "' class='cross'>";
        html += "  <img src='" + groupCard.card_image + "' class='small-image pull-left'>";
        html += "</a>";
        html += "  <span class='group-card-info'>" + groupCard.name + "<br><small> (" + groupCard.num_merchants + " Merchants)</small></span>";
        html += "  <a href='https://" + groupCard.slug + ".instagift.com?rc=" + nickname + "' class='btn btn-link btn-xs float-right group-card-info' target='_blank'>Buy</a>";
        html += "</li>";
      });

      html += "</ul>";
    }
    html += "</div>"

    $(listing).html(html);
    $(listing).addClass('item individual');
    if (json.offers.length) {
      $(listing).addClass('deal');
    }

    var marker = L.marker(latlng, { icon: instagiftIcon });
    marker.igSlug = json.slug;
    marker.locationSlug = locationJson.slug;
    markers.push(marker);
    clusterGroup.addLayer(marker);

    var popup = L.popup().
      setLatLng(latlng).
      setContent('<h3>' + json.name + '</h3><div>' + locationJson.address + '</div>');

    listing.marker = marker;
    marker.listing = listing;

    marker.bindPopup(popup);
    marker.clickActivated = false;
    $(listing).on('click', function(e) {
      if (!e.currentTarget.classList.contains("active")) {
        $(this.marker).trigger('click');
      }
    })

    $(marker).on('click', function(e) {
      var $listing = $("#" + this.listing.id);

      map.addLayer(this);
      setActive($listing, e);
      map.setView(this.getLatLng(), 18, { animate: true });
      this.clickActivated = true;
      this.openPopup();
    });

    $(marker).on('mouseover', function (e) {
      if (!this.clickActivated) {
        this.openPopup();
      }

    });

    $(marker).on('mouseout', function (e) {
      if (!this.clickActivated) {
        this.closePopup();
      }
    });
    });
  };

  var addGroupListing = function (json) {
    var listing = listings.appendChild(document.createElement('div'));
    listing.id = json.slug

    var html = "";
    if (json.offers.length) {
      html += "<div class='offer hide'>";
      html += "  <h3>Buy a $" + json.offers[0].x + " gift card & get a bonus $" + json.offers[0].y + "</h3>";
      html += 'This offer expires soon. Click "Buy Now" for details.';
      html += "</div>";
    }
    html += "  <a href='#' class='hide close-item float-right'>close <i class='fas fa-times-circle' aria-hidden='true'></i></a>"
    html += "  <div class='details'><img src='" + json.card_image + "' class='image h-100'></div>";
    html += "  <div class='details'>";
    html += "    <div class='title item-name'>" + json.name;

    html += "      <br>";
    html += "      <small class='quiet'>"
    html += json.tagline;
    html += "      </small>"
    html += "    </div>";

    html += "    <a href='https://" + json.slug + ".instagift.com?rc=" + nickname + "' class='btn btn-primary btn-lg buy-now-button pull-left hide' target='_blank'>Buy Now</a>";
    html += "  </div>";
    if (json.offers.length) {
      html += "<div class='details float-right circle'>";
      html += "<p><div class='amt'>$" + json.offers[0].y + "</div>Free</p>";
      html += "</div>";
    }
    html += "  <div class='clearfix'></div>";
    html += "  <div class='extra hide'>"
    html += "    <h6>This group has " + json.merchants.length + " merchant members:</h6>";

    html += "    <div class='merchant-images'>";
    json.merchants.forEach(function(merchant){
      html += "<span class='gift-card-merchant'>";
      html += "  <a href='#" + merchant.slug + "' class='cross'>";
      html += '    <img src="' + merchant.card_image + '" class="small-image" alt="' + merchant.name + '">';
      html += "  </a>";
      html += merchant.name
      html += "</span>";
    });
    html += "    </div>";

    html += "  </div>";

    $(listing).addClass('item group');
    $(listing).html(html);

    if (json.offers.length) {
      $(listing).addClass('deal');
    }

    latlngs = json.coordinates.map(function(c) {
      latlng = L.latLng(c.latitude, c.longitude);

      boundPointsForMap.push(latlng);
      return latlng;
    });

    if (latlngs.length) {
      polygon = L.polygon(latlngs, { color: defaultPolygonColor });
      polygon.highlightColor = json.color;
      polygon.addTo(map);
    } else {
      polygon = L.polygon([])
    }
    polygon.igSlug = json.slug;
    polygon.igMerchantSlugs = json.merchants.map(function(merchant)
      { return merchant.slug }
    );
    polygons.push(polygon);
    listing.polygon = polygon;

    $(polygon).on('click', function(e) {
      var clickedPolygon = this;
      var bounds = this.getBounds();
      this.setStyle({color: this.highlightColor});

      if (bounds.isValid()) {
        map.fitBounds(bounds);
      }
      setActive($(listing), e);

      polygons.forEach(function(polygon) {
        if (polygon != clickedPolygon) {
          map.removeLayer(polygon);
        }
      });

      // only show markers that are part of the selected group
      clusterGroup.clearLayers();

      markers.forEach(function(marker) {
        if (clickedPolygon.igMerchantSlugs.indexOf(marker.locationSlug) >= 0) {
          clusterGroup.addLayer(marker);
        }
      });
    });

    $(listing).on('click', function(e) {
      if (!e.currentTarget.classList.contains("active")) {
        $(this.polygon).trigger("click");
      }
    });
  };

  var getGroups = function() {
    slug = $("#map").data("slug");

    if (merchantData != null) {
      loadData();
    } else {
      $.ajax({
        url: "/" + slug + ".json",
        success: function(response){
          merchantData = response.data;
          alphabetizedMerchants = merchantData.individual_cards;
  
          loadData();
        }
      });
    }
  };

  var loadData = function() {
    if ($("#alphabetize")[0].checked) {
      merchants = alphabetizedMerchants;
    } else {
      if (shuffledMerchants === null) {
        // shuffledMerchants = merchantData.individual_cards.shuffle();
        shuffledMerchants = merchantData.individual_cards.filter(e => e.offers.length > 0).shuffle().concat(
          merchantData.individual_cards.filter(e => e.offers.length === 0).shuffle()
        );
      }

      merchants = shuffledMerchants;
    }

    if (merchantData.featured_merchant) {
      addFeaturedListing(merchantData.featured_merchant);
    }

    merchantData.group_cards.forEach(function(card) {
      addGroupListing(card);
    });

    merchants.forEach(function(card) {
      addMerchantListing(card);
    });

    setMapBounds();
    map.addLayer(clusterGroup);

    if (!$(".item.deal").length) {
      $(".deals-only").addClass("hide");
    }

    $("#deals-only, #individuals-only, #all-cards, #groups-only").trigger("change");

    if (window.location.hash != "") {
      setActive($(window.location.hash), e);
    }
  };

  var setMapBounds = function() {
    bounds = L.polygon(boundPointsForMap).getBounds();
    map.fitBounds(bounds);
  };

  getGroups(true);

  var currentDate = new Date();
  var futureDate  = new Date("2017-11-23T00:00:01-06:00");

  var diff = futureDate.getTime() / 1000 - currentDate.getTime() / 1000;

  clock = $('.clock').FlipClock(diff, {
    clockFace: 'DailyCounter',
    countdown: true
  });

  // if ($(window).width() < 700 || window.location.hash != "") {
  //   $(".overlay").attr("style", "display:none");
  //   $(".overlay").trigger("click");
  // }
  $(".overlay").attr("style", "display:none");
  $(".overlay").trigger("click");

  window.onpopstate = function(e) {
    if (window.location.hash === "") {
      closeActive();
    } else {
      setActive($(window.location.hash), e);
    }
  };
});

Array.prototype.shuffle = function() {
  return this.map(function(n){
    return [Math.random(), n] }
  ).sort().map(function(n){
    return n[1]
  });
}
